import { Modal, Button, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { User } from '../../services/user.service';
import { formatUserName } from '../../utils/name.util';

interface UserDeleteModalProps {
  show: boolean;
  onHide: () => void;
  user: User | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function UserDeleteModal({
  show,
  onHide,
  user,
  onConfirm,
  isLoading,
}: UserDeleteModalProps) {
  const { t, i18n } = useTranslation();
  if (!user) return null;

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={!isLoading}>
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>{t('users.delete_confirm_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3">
          <div className="fw-semibold mb-0">{t('common.delete_data_irreversible')}</div>
        </Alert>
        <p className="mb-3">{t('users.delete_confirm_message')}</p>
        <div>
          <p><strong>{t('users.field_username')}:</strong> {user.username}</p>
          <p><strong>{t('users.field_email_label')}:</strong> {user.email}</p>
          <p><strong>{t('users.field_name_label')}:</strong> {formatUserName(user.firstName, user.lastName, i18n.language) || user.username || '-'}</p>
          <p><strong>{t('users.field_role_label')}:</strong> {user.role?.name || '-'}</p>
        </div>
        <div className="mt-3">
          <small className="text-muted">
            {t('users.delete_warning')}
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t('common.deleting') : t('common.delete_confirm_ok')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

